import React from 'react';
import HistoryIcon from '@mui/icons-material/History';

interface Props {
  kind: 'query' | 'options';
  shownFor: string;
  changedOptions: string[];
  canRun: boolean;
  onRun: () => void;
  onRevert: () => void;
}

const StaleNotice: React.FC<Props> = ({
  kind,
  shownFor,
  changedOptions,
  canRun,
  onRun,
  onRevert,
}) => {
  const isQuery = kind === 'query';
  return (
    <div className='psc-stale'>
      <span className='psc-stale-glyph'>
        <HistoryIcon sx={{ fontSize: 16 }} />
      </span>
      <p className='psc-stale-text'>
        {isQuery ? (
          <>
            These results are for <strong>{shownFor}</strong>. Run the screen to
            replace them.
          </>
        ) : (
          <>
            These results use the previous{' '}
            <strong>{changedOptions.join(' and ')}</strong>. Run again to apply
            the new {changedOptions.length > 1 ? 'settings' : 'one'}.
          </>
        )}
      </p>
      <div className='psc-stale-actions'>
        <button
          type='button'
          className='psc-btn psc-btn--sm'
          onClick={onRevert}
          aria-label={
            isQuery
              ? `Go back to ${shownFor}`
              : 'Go back to the previous settings'
          }
        >
          Go back
        </button>
        {canRun && (
          <button
            type='button'
            className='psc-primary psc-primary--sm'
            onClick={onRun}
          >
            {isQuery ? 'Run screening' : 'Run again'}
          </button>
        )}
      </div>
    </div>
  );
};

export default StaleNotice;
